<template>
	<transition name="modal">
		<div class="modal-mask">
			<div class="modal-wrapper" @click="$emit('closeModal')">
				<div class="row">
					<div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
					<div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
						<div class="modal-container" @click.stop>

						<div class="modal-header row" style="justify-content: flex-end;">
							<div class="col">
								<button type="button" class="close" @click="$emit('closeModal')">
									<span aria-hidden="true">&times;</span>
								</button>
							</div>
						</div>
						<!-- Start Modal Body -->
						<div class="modal-body" style="min-height:50vh;" v-if="sparepartListBahan && sparepartListOthers">
							<h2 class="title">Tambah Sparepart</h2>

							<div class="row row-space">
								<div class="col-12">
									<div class="input-group">
										<label>Pilih Tipe Sparepart</label>
										<MultiSelect 
											:options="sparepartType.map(x => x.variable)"
											:custom-label="opt => sparepartType.find(x => x.variable == opt).name"
											v-model="form.sparepart_type"
											:allow-empty="false"
										/>
									</div>
								</div>
							</div>

							<div class="row row-space">
								<div class="col-12">
									<div class="input-group">
										<label>Pilih Sparepart</label>
										<MultiSelect 
											:options="selectedList.map(x => x.id)"
											:custom-label="opt => selectedList.find(x => x.id == opt).name"
											v-model="selectedSparepart"
										/>
									</div>
								</div>
							</div>

							<!-- <div class="row row-space" v-if="selectedSparepart">
								<div class="col-6 pl-5">
									<h5>Satuan Pembagi</h5>
								</div>
								<div class="col-1">
									<h5>:</h5>
								</div>
								<div class="col-5">
									<h5>{{selectedList.find( x=> x.id == selectedSparepart).pembagi}}</h5>
								</div>
							</div> -->

							<div class="row row-space">
								<div class="col-3">
									<div class="input-group">
										<label>Jumlah Pembelian</label>
										<input type="text"  v-model="form.amount" class="input--style-4"/>
									</div>
								</div>
								<div class="col-1 mt-auto mb-auto text-center">
									<h3>X</h3>
								</div>
								<div class="col-3">
									<div class="input-group">
										<label>Pembagi</label>
										<input disabled type="text" :value="selectedSparepart ? selectedList.find( x=> x.id == selectedSparepart).pembagi : 0" class="input--style-4"/>
									</div>
								</div>
								<div class="col-1 mt-auto mb-auto text-center">
									<h3>=</h3>
								</div>
								<div class="col-3">
									<div class="input-group">
										<label>Total Stock Masuk</label>
										<input disabled type="text" :value="selectedSparepart && form.amount ? numberWithCommas(parseFloat(selectedList.find( x=> x.id == selectedSparepart).pembagi) * parseFloat(form.amount.split(',').join(''))) : 0" class="input--style-4"/>
									</div>
								</div>
							</div>

							<div class="row row-space">
								<div class="col-12">
									<div class="input-group">
										<label>Total Harga Pembelian</label>
										<input type="text"  v-model="form.price" class="input--style-4"/>
									</div>
								</div>
							</div>

							<div class="row">
								<div class="col-6 col-md-3 offset-md-3 text-center">
									<button type="button" class="btn btn-danger btn-md" @click="$emit('closeModal')">Cancel</button>
								</div>
								<div class="col-6 col-md-3 text-center">
									<button type="button" class="btn btn-primary btn-md" @click="addSparepart()">Tambah</button>
								</div>
							</div>
							
						</div>
						<!-- End Modal Body -->
					</div>
				</div>
			</div>
			<div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
		</div>
  </div>

 
</transition>
</template>

<script>
import MultiSelect from 'vue-multiselect'
export default {
	components : {
		MultiSelect
	},
	data () {
		return {
			options : this.$store.getters.getFilterOptions,
			sparepartListBahan : null,
			sparepartListOthers : null,
			form : {
				sparepart_type : 'B',
				sparepart_id : null,
				sparepart_name : null,
				amount : null,
				price : null
			},
			selectedSparepart : null,
			selectedList : null,
			sparepartType : [{
				name : 'Bahan',
				variable : 'B'
			}, {
				name : 'Special Bahan',
				variable : 'L'
			}],
			
		}
  	},
  	watch : {
		'form.amount' : function () {
			const result = this.form.amount.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			this.$nextTick(() => this.form.amount = result);
		},
		'form.price' : function () {
			const result = this.form.price.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			this.$nextTick(() => this.form.price = result);
		},
		selectedSparepart () {
			this.searchSparepartID(this.selectedSparepart)
		},
		'form.sparepart_type' () {
			this.form.sparepart_id = null
			this.selectedList = this.form.sparepart_type == 'B' ? this.sparepartListBahan : this.sparepartListOthers
		}
	},
	mounted () {
		this.getSparepartVariantsBahan()
		this.getSparepartVariantsOthers()
	},
	methods : {
		validate (data) {
			let error = []

			if(!data.sparepart_id) {
				error.push('Mohon Dipilih Sparepart Terlebih Dahulu !')
			}

			

			if(!data.amount) {
				error.push('Jumlah Sparepart Tidak Boleh Kosong !')
			} else {
				// data.amount = parseInt(data.amount.split(',').join(""))
				
				data.amount = parseFloat(this.selectedList.find( x=> x.id == this.selectedSparepart).pembagi) * parseFloat(data.amount.split(',').join(''))

				if(data.amount <= 0) {
					error.push('Jumlah Sparepart Harus Lebih dari 0')
				}
			}

			if(!data.price) {
				error.push('Harga Sparepart Tidak Boleh Kosong !')
			} else {
				data.price = parseInt(data.price.split(',').join(""))

				if(data.price <= 0) {
					error.push('Harga Sparepart Harus Lebih dari 0')
				}
			}

			
			return error
		},
		async addSparepart() {
			let data = Object.assign({} , this.form)

			
			

			let error = await this.validate(data)

			if(error.length > 0) {
				this.$store.dispatch('triggerAlert' , [false , error])
				return
			}

			
			this.$emit('updateData' , data)
		},
		searchSparepartID (sparepart) {
			let url = `/api/v1/masterData/sparepart`

			this.$http.get(url + `?variant_id=${sparepart}`)
			.then((resp) => {
				let data = resp.data.data[0]
				this.form.sparepart_id = data.id
				this.form.sparepart_name = data.sparepart_variants.name
			})
			.catch((err) => {
				console.log(err)
			})
	
		},
		getSparepartVariantsBahan() {
			this.$http.get('/api/v1/masterData/sparepart/variants?sparepart_type_id=3&pagination=false')
			.then((resp) => {
				this.sparepartListBahan = resp.data.data
				this.selectedList = this.sparepartListBahan
			})
			.catch((err) => {
				console.log(err)
				this.$store.dispatch('triggerAlert', [false, [err]]);
			})
		},
		getSparepartVariantsOthers() {
			this.$http.get('/api/v1/masterData/sparepart/variants?sparepart_type_id=4&pagination=false')
			.then((resp) => {
				this.sparepartListOthers = resp.data.data
			})
			.catch((err) => {
				console.log(err)
				this.$store.dispatch('triggerAlert', [false, [err]]);
			})
		}
	},
}
</script>

<style scoped>
	.input--style-4:disabled {
		/* Mozilla Firefox 4 to 18 */
		color: white !important;
	}
</style>

<style>

td {
	vertical-align: middle !important;
}

/* ==========================================================================
#form made by Colorlib (https://colorlib.com)
========================================================================== */
input {
  outline: none;
  margin: 0;
  border: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  width: 100%;
  font-size: 14px;
  font-family: inherit;
}

.input--style-4 {
  line-height: 50px;
  background: #fafafa;
  -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  padding: 0 20px;
  font-size: 16px;
  color: #666;
  -webkit-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  transition: all 0.4s ease;
}
c

.input--style-4:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #666;
  opacity: 1;
}

.input--style-4::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #666;
  opacity: 1;
}

.input--style-4:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #666;
}

.input--style-4:-ms-input-placeholder {
  /* Microsoft Edge */
  color: #666;
}

.label {
  font-size: 16px;
  color: #555;
  text-transform: capitalize;
  display: block;
  margin-bottom: 5px;
}

.radio-container {
  display: inline-block;
  position: relative;
  padding-left: 30px;
  cursor: pointer;
  font-size: 16px;
  color: #666;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.radio-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.radio-container input:checked ~ .checkmark {
  background-color: #e5e5e5;
}

.radio-container input:checked ~ .checkmark:after {
  display: block;
}

.radio-container .checkmark:after {
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 12px;
  height: 12px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  background: #57b846;
}

.checkmark {
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #e5e5e5;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.input-group {
  position: relative;
  /* margin-bottom: 22px; */
  padding:20px;
}

.input-group-icon {
  position: relative;
}

.input-icon {
  position: absolute;
  font-size: 18px;
  color: #999;
  right: 18px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  cursor: pointer;
}

/* ==========================================================================
    #TITLE made by Colorlib (https://colorlib.com)
    ========================================================================== */
.title {
  font-size: 35px;
  color: #525252;
  margin-bottom: 40px;
  text-align: center;
}


/* FILE DRAG N' DROP START */
.dropZone {
  /* width: 80%; */
  height: 200px;
  position: relative;
  border: 2px dashed #eee;
}

.dropZone:hover {
  border: 2px solid #2e94c4;
}

.dropZone:hover .dropZone-title {
  color: #1975A0;
}

.dropZone-info {
  color: #A8A8A8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.dropZone-title {
  color: #787878;
}

.dropZone input {
  position: absolute;
  cursor: pointer;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.dropZone-upload-limit-info {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

.dropZone-over {
  background: #5C5C5C;
  opacity: 0.8;
}

.dropZone-uploaded {
  /* width: 80%; */
  height: 200px;
  position: relative;
  border: 2px dashed #eee;
}

.dropZone-uploaded-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #A8A8A8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.removeFile {
  width: 200px;
}
/* FILE DRAG N' DROP END */


</style>
